<template>
  <v-card :style="{ 'min-height': `${height}px`}" :class="['d-flex', 'flex-grow-1', { 'primary': dark}, {'darken-4' : dark}]" :dark="dark">
    <v-badge v-if="comingSoon" overlap tile color="success" :content="$t('common.comingSoon')"></v-badge>
    <!-- loading spinner -->
    <div v-if="loading" class="d-flex flex-grow-1 align-center justify-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <!-- information -->
    <div v-else class="d-flex flex-column flex-grow-1">
      <v-card-title>
        <div>{{ label }}</div>
        <v-spacer></v-spacer>
        <v-btn v-if="actionLabel" text color="primary" @click="$emit('action-clicked')">{{ actionLabel }}</v-btn>
      </v-card-title>      
      <!--
      <v-row justify="space-between">
        <div>
          <div class="pa-2">
          <div class="text-h4">
            {{ value }} {{ formatCurrency(currency, true) }}
          </div>
          <div class="primary--text text--lighten-1 mt-1">
            {{ valueCount }} orders
          </div>
        </div>
        </div>
        <div class="d-flex flex-column text-right">
          <div class="font-weight-bold">
            <trend-percent :value="percentage" />
          </div>
          <div class="caption">{{ percentageLabel }}</div>
        </div>
      </v-row>
      -->
      
      <div class="d-flex flex-column flex-grow-1">
        <div class="pa-2">
          <div class="text-h4">
            {{ value.toFixed(0) }} {{ formatCurrency(currency, true) }}
          </div>
          <div class="primary--text text--lighten-1 mt-1">
            {{ valueCount }} {{ countSuffix }}
          </div>
        </div>
        <!--
        <v-spacer></v-spacer>
        -->
        <div class="px-2 pb-2" v-if="percentageLabel">
          
          <div class="d-flex align-center justify-end">
            <div class="d-flex flex-column text-right">
              <div class="font-weight-bold">
                <trend-percent :value="percentage" />
              </div>
              <div class="caption">{{ percentageLabel }}</div>
            </div>
          </div>
        </div>
      </div>
      <apexchart
        class="py-1"
        type="area"
        :height="chartHeight"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </v-card>
</template>

<script>
import TrendPercent from './TrendPercent'
import Formatters from '@/mixins/formatters'

/*
|---------------------------------------------------------------------
| DEMO Dashboard Card Component
|---------------------------------------------------------------------
|
| Demo card component to be used to gather some ideas on how to build
| your own dashboard component
|
*/
export default {
  components: {
    TrendPercent
  },
  mixins: [Formatters],
  props: {
    value: {
      type: Number,
      default: 0
    },
    valueCount: {
      type: Number,
      default: 0
    },
    countSuffix: {
      type: String,
      default: 'orders'
    },
    percentage: {
      type: Number,
      default: 0
    },
    percentageLabel: {
      type: String,
    },
    series: {
      type: Array,
      default: () => [{
        name: 'Sales',
        data: [11, 32, 45, 32, 34, 52, 41]
      }]
    },
    xaxis: {
      type: Object,
      default: () => ({
        type: 'datetime',
        categories: [
          '2018-09-19T00:00:00.000Z',
          '2018-09-20T00:00:00.000Z',
          '2018-09-21T00:00:00.000Z',
          '2018-09-22T00:00:00.000Z',
          '2018-09-23T00:00:00.000Z',
          '2018-09-24T00:00:00.000Z',
          '2018-09-25T00:00:00.000Z'
        ]
      })
    },
    label: {
      type: String,
      default: 'Sales'
    },
    actionLabel: {
      type: String
    },
    options: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: 'USD'
    },
    height: {
      type: Number,
      default: 200
    },
    chartHeight: {
      type: Number,
      default: 120
    },
    comingSoon: {
      type: Boolean
    }
  },
  computed: {
    chartOptions() {
      let t = this;
      const primaryColor = this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark.primary
        : this.$vuetify.theme.themes.light.primary
      const secondaryColor = this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark.success
        : this.$vuetify.theme.themes.light.success
      return {
        chart: {
          height: this.chartHeight,
          type: 'area',
          sparkline: {
            enabled: true
          },
          animations: {
            speed: 400
          }
        },
        colors: [primaryColor, secondaryColor],
        fill: {
          type: 'solid',
          colors: [primaryColor, secondaryColor],
          opacity: 0.15
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        xaxis: this.xaxis,
        //yaxis: this.series.map(s => {return { title: { text: s.title }, show: false }}),
        yaxis: t.series.map(s => { return { seriesName: s.name, min: 0, max: (n) => n + Math.pow(10,(Math.log10(n) - 1)), show: false }}),
        tooltip: {
          followCursor: true,
          theme: this.dark ? 'dark' : 'light',
          style: {
            fontFamily: 'Quicksand, sans-serif'
          },
          x: {
            format: 'd.M.yyyy',
          },
          y: {
            formatter: function(value, { /*series,*/ seriesIndex, /*dataPointIndex, w */}) {
              return `${t.formatNumber(value,seriesIndex == 0 ? 2 : 0)} ${seriesIndex == 0 ? t.formatCurrency(t.currency, true) : ''}`;
            }
          },
          /*
          custom: function({ ctx, series, seriesIndex, dataPointIndex, w }) {
            const seriesName = w.config.series[seriesIndex].name

            return `<div class="rounded-lg pa-1 caption">
              <div class="font-weight-bold">${t.formatDate(w.globals.labels[dataPointIndex])}</div>
              <div>${series[seriesIndex][dataPointIndex]} ${seriesName} ${seriesIndex == 0 ? t.formatCurrency(this.currency, true) : ''}</div>
            </div>`
          }
          */
        },
        ...this.options
      }
    }
  },
  methods: {
  }
}
</script>
